module.exports = __webpack_public_path__ + "img/marketing-3.fb66b3a7.png";